import {INavigateLinkOptions} from "../links-navigation.service.interface";

export enum RegulationNavigationHookContinuationMode {
    Continue,
    Block
}

export interface IRegulationLinkNavigationHookResult {
    continuationMode: RegulationNavigationHookContinuationMode;
    options?: INavigateLinkOptions
}

export interface IRegulationLinkNavigationHook {
    navigateLink(options: INavigateLinkOptions): Promise<IRegulationLinkNavigationHookResult>;
}